/**
 * Origen de la tienda VTEX para redirects cuando el iframe se abre sin host (sesión inválida).
 * En embed, el checkout web resuelve la tienda y redirige el top window.
 */

const ALLOWED_STORE_HOST =
  /^(?:(?:[a-z0-9-]+--)?(?:carrefourar|poccarrefourarg)\.myvtex\.com|(?:[a-z0-9-]+\.)?carrefour\.com\.ar)$/i;

const toAllowedOrigin = (value: string | null | undefined): string | undefined => {
  if (!value) return undefined;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:') return undefined;
    if (!ALLOWED_STORE_HOST.test(url.hostname)) return undefined;
    return url.origin;
  } catch {
    return undefined;
  }
};

/** `iframe-poc-ecomnattesting.carrefour.com.ar` → `https://ecomnattesting.carrefour.com.ar` */
const fromIframeHostname = (hostname: string): string | undefined => {
  const match = /^iframe(?:-poc)?-(.+)\.carrefour\.com\.ar$/i.exec(hostname);
  if (!match?.[1]) return undefined;
  return toAllowedOrigin(`https://${match[1]}.carrefour.com.ar`);
};

export const resolveStoreBaseUrl = (): string | undefined => {
  const fromEnv = toAllowedOrigin(import.meta.env.VITE_STORE_BASE_URL);
  if (fromEnv) return fromEnv;

  if (typeof window !== 'undefined') {
    const fromReferrer = toAllowedOrigin(document.referrer);
    if (fromReferrer) return fromReferrer;

    const fromHost = fromIframeHostname(window.location.hostname);
    if (fromHost) return fromHost;

    const fromOrigin = toAllowedOrigin(window.location.origin);
    if (fromOrigin && !/^https:\/\/iframe/i.test(fromOrigin)) return fromOrigin;
  }

  return undefined;
};
